import app from './app';
import { PAYMENT_SERVICE_URL } from '../../libs/constants';


const getAllPayments = (searchConfig) => async (dispatch, getState, api) => {    
    dispatch(app.setLoading(true));
    let url = PAYMENT_SERVICE_URL + "/list";
    //if (userId) url += "/" + userId;
    console.log('Search config : ' + JSON.stringify(searchConfig));
    const headerConfig = {
        headers: {
            //...(lspId) && {"lspId": lspId},
            "DRS-Fetch-Type": "getAllPayments"
        }
    };

    await api.post(url, searchConfig, headerConfig)
    .then(response => {
        if (response.data.paymentList) {
            dispatch({
                type: "SET_PAYMENTS_LIST",
                payload: response.data
            });
        }
        else {
            //dispatch(setAPIFetchError(true));
            //dispatch(setListRefreshed(true));
        }
        dispatch(app.setLoading(false));
    })    
    .catch(error => {        
        //dispatch(setAPIFetchError(true));
        //dispatch(app.setLoading(false));
        console.log(error);
    });
};


const quoteActions = {
    getAllPayments
}

export default quoteActions;